<template lang="pug">
#accounts-management
  v-banner.title-banner(min-height="88")
    .text-h4.font-weight-bold {{ title }}
    template(v-slot:actions)
      v-btn.ml-6(rounded, color="primary", @click="addItem(null)") {{ $t('ChartOfAccounts.__AddAccount') }}
  v-container
    v-tabs
      v-tab(to="#assets")
        span {{ $t('AccountGroups.__Assets') }}
      v-tab(to="#liabilities") 
        span {{ $t('AccountGroups.__Liabilities') }}
      v-tab(to="#income") 
        span {{ $t('AccountGroups.__Income') }}
      v-tab(to="#operating-expenses") 
        span {{ $t('AccountGroups.__OperatingExpenses') }}
      v-tab(to="#operating-costs") 
        span {{ $t('AccountGroups.__OperatingCosts') }}
      v-tab(to="#owners-equity")
        span {{ $t('AccountGroups.__OwnersEquity') }}
    v-divider
    Alert
    ConfirmDialog(
      v-model="deleteDialog",
      :title="$t('ChartOfAccounts.__DeleteAccount')",
      :message="$t('ChartOfAccounts.__ConfirmDeleteAccount')",
      :cancel-text="$t('ActionOption.__Cancel')",
      :confirm-text="$t('ActionOption.__Delete')",
      :confirm-action="deleteAccount"
    )

    .accounting-table.mt-2(v-for="category in nowGroup")
      v-data-table(
        :headers="headers",
        :items="category.accounts",
        :items-per-page="category.accounts.length",
        hide-default-footer,
        hide-default-header
      )
        template(v-slot:header="{ props: { headers } }")
          thead(style="background-color: #fae3d8")
            tr
              th(colspan="3") 
                .d-flex.align-center.justify-space-between
                  span {{ $t('AccountCategories.__' + category.key) }}
                  v-btn(text, small, color="primary", @click="addItem(category.key)", v-if="category.key != 'SaleTaxes'") 
                    v-icon(left, small) add
                    .d-md-block.d-none {{ $t('ChartOfAccounts.__AddAccount') }}
        template(v-slot:body="{ items }")
          tbody
            tr(v-for="item in items")
              td.category-name(:class="item.isArchived ? 'archived' : ''") {{ getAccountTranslatedName(item.name) }}
              td.description.d-md-table-cell.d-none {{ item.description }}
              td.actions.text-right(v-if="category.key != 'SaleTaxes'")
                v-btn.ma-0(v-if="item.isEditable", text, icon, small, color="primary", @click="editItem(item)", title="edit")
                  v-icon(small) edit
                v-btn.ma-0(
                  v-if="item.isEditable",
                  text,
                  icon,
                  small,
                  color="primary",
                  @click="deleteDialog = true; deleteId = item.id",
                  title="delete",
                  :disabled="item.isArchived"
                )
                  v-icon(small) delete

        //- template(v-slot:item.category="{ item }")
        //-     .category-name(:class="item.isArchived ? 'archived' : ''") {{ getAccountTranslatedName(item.name) }}

        //- template(v-slot:item.description="{ item }")
        //-     .description {{ item.description }}

        //- template(v-slot:item.actions="{ item }" v-if="category.key != 'SaleTaxes'")
        //-     v-btn.ma-0(
        //-         v-if="item.isEditable",
        //-         text,
        //-         icon,
        //-         small,
        //-         color="primary",
        //-         @click="editItem(item)",
        //-         title="edit"
        //-     )
        //-         v-icon(small) edit
        //-     v-btn.ma-0(
        //-         v-if="item.isEditable",
        //-         text,
        //-         icon,
        //-         small,
        //-         color="primary",
        //-         @click="deleteDialog=true; deleteId=item.id",
        //-         title="delete"
        //-     )
        //-         v-icon(small) delete

  EditAccountDialog(v-model="editDialog", :edited-item="editedItem", :edit-type="editType", :confirm-action="editDone")
</template>
<script>
import * as textfieldUtils from "@/utils/textfield.js"
import EditAccountDialog from "@/components/accounting/EditAccountDialog"
import * as accountHelper from "@/utils/accountHelper"

export default {
  mixins: [accountHelper.mixin],
  components: {
    EditAccountDialog
  },
  data() {
    return {
      title: this.$t("Menu.__Accounting") + " : " + this.$t("Menu.__ChartOfAccounts"),
      nowGroupKey: "",
      nowGroup: [],
      nowData: {},
      editDialog: false,
      deleteDialog: false,
      deleteId: 0,
      editType: 1,
      editedItem: {},
      // formValid: false,
      // rules: textfieldUtils.rules,
      hashKeyMapping: {
        "#assets": "Assets",
        "#liabilities": "Liabilities",
        "#income": "Income",
        "#operating-expenses": "OperatingExpenses",
        "#operating-costs": "OperatingCosts",
        "#owners-equity": "OwnersEquity"
      },
      headers: [
        {
          text: "Category Name",
          align: "start",
          sortable: false,
          value: "category"
        },
        {
          text: "Description",
          align: "start",
          sortable: true,
          value: "description"
        },
        {
          text: "",
          align: "end",
          sortable: true,
          value: "actions"
        }
      ],
      accountings: {},
      categoriesMapping: {},
      groups: []
    }
  },
  watch: {
    nowGroupKey(value) { },
    urlHash(value) {
      if (value in this.hashKeyMapping) {
        this.nowGroupKey = this.hashKeyMapping[value]
        this.getData()
      } else {
        this.$router.push("#assets")
      }
    }
  },
  computed: {
    urlHash() {
      return this.$route.hash
    }
  },
  methods: {
    async getData() {
      this.nowGroup = this.accountings[this.nowGroupKey]
      // this.nowGroup = this.categoriesMapping[this.nowGroupKey]
      // this.nowGroup.map(category => {
      //     category.name = this.$t("__" + category.key)
      // })
      // this.nowData = new Object()
      // var functions = []
      // this.nowGroup.map(category => {
      //     functions.push(this.getAccountsByCategory(category.key))
      // })
      // var result = await Promise.all(functions)
      // this.$store.dispatch("global/stopLoading")
    },
    getCategories() {
      this.$store
        .dispatch("accounting/getCategories")
        .then(
          function (response) {
            this.groups = response.data.groups
            this.groups.map(
              function (group) {
                this.categoriesMapping[group.key] = group.categories
              }.bind(this)
            )

            this.accountings = {}
            for (var group of response.data.groups) {
              this.accountings[group.key] = {}
              for (var category of group.categories) {
                this.accountings[group.key][category.key] = {
                  key: category.key,
                  accounts: []
                }
              }
            }

            this.getAccounts()
            // this.getData()
          }.bind(this)
        )
        .catch(
          function (error) {
            this.$store.dispatch("global/showAlert", {
              type: "error",
              message: error.message
            })
          }.bind(this)
        )
    },
    resetAccounts() {
      for (var groupKey in this.accountings) {
        for (var categoryKey in this.accountings[groupKey]) {
          this.accountings[groupKey][categoryKey].accounts = []
        }
      }
    },
    getAccounts() {
      this.$store
        .dispatch("accounting/getAccounts")
        .then(
          function (response) {
            this.resetAccounts()
            for (var group of response.data.groups) {
              for (var category of group.categories) {
                this.accountings[group.key][category.key].accounts = category.accounts
              }
            }
            this.getData()
          }.bind(this)
        )
        .catch(
          function (error) {
            this.$store.dispatch("global/showAlert", {
              type: "error",
              message: error.message
            })
          }.bind(this)
        )
    },
    // getAccountsByCategory(key) {
    //     this.$store
    //         .dispatch("accounting/getAccountsByCategory", key)
    //         .then(
    //             function(response) {
    //                 // this.accountings = response.data.groups
    //                 this.$set(this.nowData, key, response.data)
    //                 return Promise.resolve(true)
    //             }.bind(this)
    //         )
    //         .catch(
    //             function(error) {
    //                 return Promise.reject(error)
    //             }.bind(this)
    //         )
    // },
    addItem(category) {
      // this.$refs.accountingForm.resetValidation()
      this.editType = 1
      this.editDialog = true
      this.editedItem = {
        category: category
      }
    },
    editItem(obj) {
      // this.$refs.accountingForm.resetValidation()
      this.editType = 2
      this.editedItem = JSON.parse(JSON.stringify(obj))
      this.editDialog = true
    },
    editDone() {
      this.getAccounts()
    },
    deleteAccount() {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("accounting/deleteAccount", this.deleteId)
        .then(
          function (response) {
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyDeleted"))
            this.getAccounts()
          }.bind(this)
        )
        .catch(
          function (error) {
            this.$store.dispatch("global/showAlertError", error.message)
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
      this.deleteDialog = false
    }
  },
  mounted() {
    var hash = "#assets"
    if (this.$route.hash in this.hashKeyMapping) {
      hash = this.$route.hash
    } else {
      this.$router.push("#assets")
    }
    this.nowGroupKey = this.hashKeyMapping[hash]
  },
  created() {
    this.getCategories()
    // this.getAccounts()
  }
}
</script>

<style lang="scss" scoped>
.category-name.archived {
  color: #b4b9be;
}
</style>
